module.exports = __webpack_public_path__ + "img/61fe050.svg";